// A written-bar range on the score/chart. Practice looping and note
// copy/paste share this span so "what you selected" is one fact.

export interface Passage {
  fromMeasureId: string;
  toMeasureId: string;
}

export interface PassageRange {
  from: number;
  to: number;
}

/** Inclusive, order-normalised indices into `ids`, or null if either end is missing. */
export function passageRange(ids: readonly string[], passage: Passage): PassageRange | null {
  const from = ids.indexOf(passage.fromMeasureId);
  const to = ids.indexOf(passage.toMeasureId);
  if (from < 0 || to < 0) return null;
  return from <= to ? { from, to } : { from: to, to: from };
}

export function normalizePassage(
  ids: readonly string[],
  a: string,
  b: string,
): Passage | null {
  const range = passageRange(ids, { fromMeasureId: a, toMeasureId: b });
  if (!range) return null;
  return { fromMeasureId: ids[range.from]!, toMeasureId: ids[range.to]! };
}

export function passageMeasureIds(ids: readonly string[], passage: Passage): string[] {
  const range = passageRange(ids, passage);
  if (!range) return [];
  return ids.slice(range.from, range.to + 1);
}

export function measureInPassage(
  ids: readonly string[],
  passage: Passage | null,
  id: string,
): boolean {
  if (!passage) return false;
  const range = passageRange(ids, passage);
  if (!range) return false;
  const i = ids.indexOf(id);
  return i >= range.from && i <= range.to;
}

/** 1-based "bar 5" / "bars 5–8" for the loop chip and Play label. */
export function passageLabel(ids: readonly string[], passage: Passage): string | null {
  const range = passageRange(ids, passage);
  if (!range) return null;
  return range.from === range.to
    ? `bar ${range.from + 1}`
    : `bars ${range.from + 1}–${range.to + 1}`;
}
